"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QueryClientImpl = exports.QueryAllQuoteResponse = exports.QueryAllQuoteRequest = exports.QueryQuoteResponse = exports.QueryQuoteRequest = exports.QueryAllRfqResponse = exports.QueryAllRfqRequest = exports.QueryRfqResponse = exports.QueryRfqRequest = exports.QueryParamsResponse = exports.QueryParamsRequest = exports.protobufPackage = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const params_1 = require("./params");
const rfq_1 = require("./rfq");
const pagination_1 = require("../../../cosmos/base/query/v1beta1/pagination");
const quote_1 = require("./quote");
exports.protobufPackage = "Switcheo.carbon.otc";
const baseQueryParamsRequest = {};
exports.QueryParamsRequest = {
    encode(_, writer = minimal_1.default.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    fromPartial(_) {
        const message = Object.assign({}, baseQueryParamsRequest);
        return message;
    },
};
const baseQueryParamsResponse = {};
exports.QueryParamsResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.params !== undefined) {
            params_1.Params.encode(message.params, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryParamsResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.params = params_1.Params.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        message.params =
            object.params !== undefined && object.params !== null
                ? params_1.Params.fromJSON(object.params)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.params !== undefined &&
            (obj.params = message.params ? params_1.Params.toJSON(message.params) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryParamsResponse);
        message.params =
            object.params !== undefined && object.params !== null
                ? params_1.Params.fromPartial(object.params)
                : undefined;
        return message;
    },
};
const baseQueryRfqRequest = { id: "" };
exports.QueryRfqRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryRfqRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryRfqRequest);
        message.id =
            object.id !== undefined && object.id !== null ? String(object.id) : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryRfqRequest);
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryRfqResponse = {};
exports.QueryRfqResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.rfq !== undefined) {
            rfq_1.RfqWithStatus.encode(message.rfq, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryRfqResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rfq = rfq_1.RfqWithStatus.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryRfqResponse);
        message.rfq =
            object.rfq !== undefined && object.rfq !== null
                ? rfq_1.RfqWithStatus.fromJSON(object.rfq)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.rfq !== undefined &&
            (obj.rfq = message.rfq ? rfq_1.RfqWithStatus.toJSON(message.rfq) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryRfqResponse);
        message.rfq =
            object.rfq !== undefined && object.rfq !== null
                ? rfq_1.RfqWithStatus.fromPartial(object.rfq)
                : undefined;
        return message;
    },
};
const baseQueryAllRfqRequest = {
    requester: "",
    buyDenom: "",
    status: "",
};
exports.QueryAllRfqRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.requester !== "") {
            writer.uint32(10).string(message.requester);
        }
        if (message.buyDenom !== "") {
            writer.uint32(18).string(message.buyDenom);
        }
        if (message.status !== "") {
            writer.uint32(26).string(message.status);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(34).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllRfqRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.requester = reader.string();
                    break;
                case 2:
                    message.buyDenom = reader.string();
                    break;
                case 3:
                    message.status = reader.string();
                    break;
                case 4:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllRfqRequest);
        message.requester =
            object.requester !== undefined && object.requester !== null
                ? String(object.requester)
                : "";
        message.buyDenom =
            object.buyDenom !== undefined && object.buyDenom !== null
                ? String(object.buyDenom)
                : "";
        message.status =
            object.status !== undefined && object.status !== null
                ? String(object.status)
                : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.requester !== undefined && (obj.requester = message.requester);
        message.buyDenom !== undefined && (obj.buyDenom = message.buyDenom);
        message.status !== undefined && (obj.status = message.status);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c;
        const message = Object.assign({}, baseQueryAllRfqRequest);
        message.requester = (_a = object.requester) !== null && _a !== void 0 ? _a : "";
        message.buyDenom = (_b = object.buyDenom) !== null && _b !== void 0 ? _b : "";
        message.status = (_c = object.status) !== null && _c !== void 0 ? _c : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllRfqResponse = {};
exports.QueryAllRfqResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.rfqs) {
            rfq_1.RfqWithStatus.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllRfqResponse);
        message.rfqs = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.rfqs.push(rfq_1.RfqWithStatus.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllRfqResponse);
        message.rfqs = ((_a = object.rfqs) !== null && _a !== void 0 ? _a : []).map((e) => rfq_1.RfqWithStatus.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.rfqs) {
            obj.rfqs = message.rfqs.map((e) => e ? rfq_1.RfqWithStatus.toJSON(e) : undefined);
        }
        else {
            obj.rfqs = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllRfqResponse);
        message.rfqs = ((_a = object.rfqs) !== null && _a !== void 0 ? _a : []).map((e) => rfq_1.RfqWithStatus.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryQuoteRequest = { id: "" };
exports.QueryQuoteRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.id !== "") {
            writer.uint32(10).string(message.id);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryQuoteRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.id = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryQuoteRequest);
        message.id =
            object.id !== undefined && object.id !== null ? String(object.id) : "";
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.id !== undefined && (obj.id = message.id);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryQuoteRequest);
        message.id = (_a = object.id) !== null && _a !== void 0 ? _a : "";
        return message;
    },
};
const baseQueryQuoteResponse = {};
exports.QueryQuoteResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.quote !== undefined) {
            quote_1.QuoteWithStatus.encode(message.quote, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryQuoteResponse);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.quote = quote_1.QuoteWithStatus.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryQuoteResponse);
        message.quote =
            object.quote !== undefined && object.quote !== null
                ? quote_1.QuoteWithStatus.fromJSON(object.quote)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.quote !== undefined &&
            (obj.quote = message.quote
                ? quote_1.QuoteWithStatus.toJSON(message.quote)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseQueryQuoteResponse);
        message.quote =
            object.quote !== undefined && object.quote !== null
                ? quote_1.QuoteWithStatus.fromPartial(object.quote)
                : undefined;
        return message;
    },
};
const baseQueryAllQuoteRequest = {
    quoter: "",
    rfqId: "",
    denom: "",
    minQuantity: "",
    maxQuantity: "",
    status: "",
};
exports.QueryAllQuoteRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.quoter !== "") {
            writer.uint32(10).string(message.quoter);
        }
        if (message.rfqId !== "") {
            writer.uint32(18).string(message.rfqId);
        }
        if (message.denom !== "") {
            writer.uint32(26).string(message.denom);
        }
        if (message.minQuantity !== "") {
            writer.uint32(34).string(message.minQuantity);
        }
        if (message.maxQuantity !== "") {
            writer.uint32(42).string(message.maxQuantity);
        }
        if (message.status !== "") {
            writer.uint32(50).string(message.status);
        }
        if (message.pagination !== undefined) {
            pagination_1.PageRequest.encode(message.pagination, writer.uint32(58).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllQuoteRequest);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.quoter = reader.string();
                    break;
                case 2:
                    message.rfqId = reader.string();
                    break;
                case 3:
                    message.denom = reader.string();
                    break;
                case 4:
                    message.minQuantity = reader.string();
                    break;
                case 5:
                    message.maxQuantity = reader.string();
                    break;
                case 6:
                    message.status = reader.string();
                    break;
                case 7:
                    message.pagination = pagination_1.PageRequest.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseQueryAllQuoteRequest);
        message.quoter =
            object.quoter !== undefined && object.quoter !== null
                ? String(object.quoter)
                : "";
        message.rfqId =
            object.rfqId !== undefined && object.rfqId !== null
                ? String(object.rfqId)
                : "";
        message.denom =
            object.denom !== undefined && object.denom !== null
                ? String(object.denom)
                : "";
        message.minQuantity =
            object.minQuantity !== undefined && object.minQuantity !== null
                ? String(object.minQuantity)
                : "";
        message.maxQuantity =
            object.maxQuantity !== undefined && object.maxQuantity !== null
                ? String(object.maxQuantity)
                : "";
        message.status =
            object.status !== undefined && object.status !== null
                ? String(object.status)
                : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.quoter !== undefined && (obj.quoter = message.quoter);
        message.rfqId !== undefined && (obj.rfqId = message.rfqId);
        message.denom !== undefined && (obj.denom = message.denom);
        message.minQuantity !== undefined &&
            (obj.minQuantity = message.minQuantity);
        message.maxQuantity !== undefined &&
            (obj.maxQuantity = message.maxQuantity);
        message.status !== undefined && (obj.status = message.status);
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageRequest.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f;
        const message = Object.assign({}, baseQueryAllQuoteRequest);
        message.quoter = (_a = object.quoter) !== null && _a !== void 0 ? _a : "";
        message.rfqId = (_b = object.rfqId) !== null && _b !== void 0 ? _b : "";
        message.denom = (_c = object.denom) !== null && _c !== void 0 ? _c : "";
        message.minQuantity = (_d = object.minQuantity) !== null && _d !== void 0 ? _d : "";
        message.maxQuantity = (_e = object.maxQuantity) !== null && _e !== void 0 ? _e : "";
        message.status = (_f = object.status) !== null && _f !== void 0 ? _f : "";
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageRequest.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
const baseQueryAllQuoteResponse = {};
exports.QueryAllQuoteResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.quotes) {
            quote_1.QuoteWithStatus.encode(v, writer.uint32(10).fork()).ldelim();
        }
        if (message.pagination !== undefined) {
            pagination_1.PageResponse.encode(message.pagination, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseQueryAllQuoteResponse);
        message.quotes = [];
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.quotes.push(quote_1.QuoteWithStatus.decode(reader, reader.uint32()));
                    break;
                case 2:
                    message.pagination = pagination_1.PageResponse.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllQuoteResponse);
        message.quotes = ((_a = object.quotes) !== null && _a !== void 0 ? _a : []).map((e) => quote_1.QuoteWithStatus.fromJSON(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromJSON(object.pagination)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.quotes) {
            obj.quotes = message.quotes.map((e) => e ? quote_1.QuoteWithStatus.toJSON(e) : undefined);
        }
        else {
            obj.quotes = [];
        }
        message.pagination !== undefined &&
            (obj.pagination = message.pagination
                ? pagination_1.PageResponse.toJSON(message.pagination)
                : undefined);
        return obj;
    },
    fromPartial(object) {
        var _a;
        const message = Object.assign({}, baseQueryAllQuoteResponse);
        message.quotes = ((_a = object.quotes) !== null && _a !== void 0 ? _a : []).map((e) => quote_1.QuoteWithStatus.fromPartial(e));
        message.pagination =
            object.pagination !== undefined && object.pagination !== null
                ? pagination_1.PageResponse.fromPartial(object.pagination)
                : undefined;
        return message;
    },
};
class QueryClientImpl {
    constructor(rpc) {
        this.rpc = rpc;
        this.Params = this.Params.bind(this);
        this.Rfq = this.Rfq.bind(this);
        this.RfqAll = this.RfqAll.bind(this);
        this.Quote = this.Quote.bind(this);
        this.QuoteAll = this.QuoteAll.bind(this);
    }
    Params(request) {
        const data = exports.QueryParamsRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.otc.Query", "Params", data);
        return promise.then((data) => exports.QueryParamsResponse.decode(new minimal_1.default.Reader(data)));
    }
    Rfq(request) {
        const data = exports.QueryRfqRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.otc.Query", "Rfq", data);
        return promise.then((data) => exports.QueryRfqResponse.decode(new minimal_1.default.Reader(data)));
    }
    RfqAll(request) {
        const data = exports.QueryAllRfqRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.otc.Query", "RfqAll", data);
        return promise.then((data) => exports.QueryAllRfqResponse.decode(new minimal_1.default.Reader(data)));
    }
    Quote(request) {
        const data = exports.QueryQuoteRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.otc.Query", "Quote", data);
        return promise.then((data) => exports.QueryQuoteResponse.decode(new minimal_1.default.Reader(data)));
    }
    QuoteAll(request) {
        const data = exports.QueryAllQuoteRequest.encode(request).finish();
        const promise = this.rpc.request("Switcheo.carbon.otc.Query", "QuoteAll", data);
        return promise.then((data) => exports.QueryAllQuoteResponse.decode(new minimal_1.default.Reader(data)));
    }
}
exports.QueryClientImpl = QueryClientImpl;
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
